import { render, staticRenderFns } from "./Permissoes.vue?vue&type=template&id=0bebd442&scoped=true"
import script from "./Permissoes.vue?vue&type=script&lang=js"
export * from "./Permissoes.vue?vue&type=script&lang=js"
import style0 from "./Permissoes.vue?vue&type=style&index=0&id=0bebd442&prod&scoped=true&lang=css"
import style1 from "./Permissoes.vue?vue&type=style&index=1&id=0bebd442&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bebd442",
  null
  
)

export default component.exports